<div class = "appointments">
    <h1>Rendez-vous ({{dealerData.appointments == undefined ? 0 : dealerData.appointments?.length}})</h1>

    <div class = "appointment-list">
        <app-appointments
            [objectSource]="objectSource" 
            >
        </app-appointments>
    </div>

</div>